import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, SetCartStatus } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { getCollectNumber } from "@tSchaedlerYesco/Store/Data/PlaceOrder/CollectNumberSelector";
import { getOrderStatus } from "@tSchaedlerYesco/Store/Data/PlaceOrder/OrderStatusSelector";
import { getReleaseNumber } from "@tSchaedlerYesco/Store/Data/PlaceOrder/ReleaseNumberSelector";

type cartStatusProps = Parameters<typeof SetCartStatus>[0];

addToChainAfter(chain, SetCartStatus, props => {
    const state = props.getState();
    props.cartToUpdate.properties = {
        ...props.cartToUpdate.properties,
        // releaseNumber: (props.getState() as any).t_data.releaseNumberState.releaseNumber,
        releaseNumber: getReleaseNumber(props.getState() as any),
        orderStatus: getOrderStatus(props.getState() as any),
        shipViaAccountNumber: getCollectNumber(props.getState() as any),
    };
    // props.cartToUpdate.status = "ef3a296d-a774-4c6c-bb69-ac8000f61ec7"; // orderStatus ||
});
